import React from 'react';
import './HeaderPreview.scss';

const HeaderPreview = ({ from, header }) => {
	const { headerText, alignment, headerSize, headerColor, dividerColor } =
		(header && header.props) || {};
	const fromButton = from === 'WidgetButton';

	return (
		<div className="WidgetPreviews">
			<div className={!from ? 'hover-wrap' : null}>
				{!from && <div className="hover-container">Header</div>}
				{fromButton ? (
					<div className="header-container">
						<div className="header" />
						<div className="line" />
					</div>
				) : (
					<div className={`header-content ${alignment}`}>
						<div className={`header-text ${headerSize}`} style={{ color: headerColor }}>
							{headerText}
						</div>
						<div className="header-divider" style={{ backgroundColor: dividerColor }} />
					</div>
				)}
			</div>
		</div>
	);
};

export default HeaderPreview;
